import React, { useEffect, useState } from 'react';

import { useIntl } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import CopyIcon from '@atlaskit/icon/core/migration/copy';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';

import messages from './messages';
import { type Props } from './types';

const ContainerStyles = xcss({
	width: 'max-content',
	marginRight: 'space.050',
});

const DomainContainerStyles = xcss({
	maxWidth: '300px',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
});

export const AfterElements: React.FC<Props> = ({ domain, currentValue }) => {
	const { formatMessage } = useIntl();
	const textRef = React.useRef<HTMLDivElement>(null);
	const [isTruncated, setIsTruncated] = useState(false);
	const [copyButtonLabel, setCopyButtonLabel] = useState(messages.copy);

	useEffect(() => {
		if (textRef.current !== null) {
			const isTextTruncated = textRef.current.scrollWidth > textRef.current.clientWidth;
			if (isTruncated !== isTextTruncated) {
				setIsTruncated(isTextTruncated);
			}
		}
	}, [isTruncated]);

	function copyToClipboard() {
		const clipboard = window.navigator.clipboard;

		clipboard.writeText(currentValue + domain).then(() => {
			setCopyButtonLabel(messages.copied);
		});
	}

	const TooltipEl = isTruncated ? Tooltip : React.Fragment;
	const tooltipProps = isTruncated ? { content: domain } : {};

	return (
		<>
			<Inline space="space.200" alignBlock="center" separator="|">
				<TooltipEl {...(tooltipProps as any)}>
					<Box ref={textRef} xcss={[ContainerStyles, DomainContainerStyles]}>
						{domain}
					</Box>
				</TooltipEl>
				<Box xcss={ContainerStyles}>
					<Tooltip content={formatMessage(copyButtonLabel)}>
						<IconButton
							label={formatMessage(messages.copyIcon)}
							appearance="subtle"
							icon={CopyIcon}
							onClick={(e) => {
								e.stopPropagation();
								copyToClipboard();
							}}
						/>
					</Tooltip>
				</Box>
			</Inline>
		</>
	);
};
